export default {
    name: 'Име',
    tel: 'Телефон',
    save: 'Запазване',
    confirm: 'Потвърдете',
    cancel: 'Отказ',
    delete: 'Изтриване',
    complete: 'Завършено',
    loading: 'Зареждане...',
    telEmpty: 'Моля, попълнете телефон',
    nameEmpty: 'Моля, попълнете име',
    nameInvalid: 'Грешно име',
    confirmDelete: 'Сигурни ли сте, че искате да изтриете?',
    telInvalid: 'Грешен телефонен номер',
    vanCalendar: {
        end: 'Край',
        start: 'Начало',
        title: 'Календар',
        startEnd: 'Начало/Край',
        weekdays: ['Нед', 'Пон', 'Вто', 'Сря', 'Чет', 'Пет', 'Съб'],
        monthTitle: (year, month) => `${year}/${month}`,
        rangePrompt: (maxRange) => `Изберете не повече от ${maxRange} дни`,
    },
    vanCascader: {
        select: 'Изберете',
    },
    vanContactCard: {
        addText: 'Добавяне на контактна информация',
    },
    vanContactList: {
        addText: 'Добавяне на нов контакт',
    },
    vanPagination: {
        prev: 'Предишен',
        next: 'Следващ',
    },
    vanPullRefresh: {
        pulling: 'Дръпнете за опресняване...',
        loosing: 'Пуснете за опресняване...',
    },
    vanSubmitBar: {
        label: 'Общо：',
    },
    vanCoupon: {
        unlimited: 'Неограничен',
        discount: (discount) => `${discount * 10}% отстъпка`,
        condition: (condition) => `Най-малко ${condition}`,
    },
    vanCouponCell: {
        title: 'Купон',
        tips: 'Няма купони',
        count: (count) => `Имате ${count} купона`,
    },
    vanCouponList: {
        empty: 'Няма купони',
        exchange: 'Обмен',
        close: 'Затваряне',
        enable: 'Наличен',
        disabled: 'Недостъпен',
        placeholder: 'Код на купон',
    },
    vanAddressEdit: {
        area: 'Област',
        postal: 'Пощенски код',
        areaEmpty: 'Моля, изберете зона за получаване',
        addressEmpty: 'Адресът не може да бъде празен',
        postalEmpty: 'Грешен пощенски код',
        defaultAddress: 'Задаване като адрес по подразбиране',
        telPlaceholder: 'Телефон',
        namePlaceholder: 'Име',
        areaPlaceholder: 'Област',
    },
    vanAddressEditDetail: {
        label: 'Адрес',
        placeholder: 'Адрес',
    },
    vanAddressList: {
        add: 'Добавяне на нов адрес',
    },
};